import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_STAFF_CARDS_ERROR, GET_STAFF_CARDS_START, GET_STAFF_CARDS_SUCCESS } from '../../types';

import apiCall from '../../../api/apiGet';

export function* get({ payload }) {
  try {
    const url = payload.lang ? `/staff-cards/${payload.lang}` : '/staff-cards';
    const method = 'GET';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: GET_STAFF_CARDS_SUCCESS, results: results.data });

  } catch (error) {
    console.log(error)
    yield put({ type: GET_STAFF_CARDS_ERROR, error });
  }
}

export default function* get_staff_cards() {
  yield takeLatest(GET_STAFF_CARDS_START, get);
}
